<template>
  <div class="rotation-groups-card">
    <AffiliateRotationGroupsPopup
      v-if="
        (currentAcl.affiliates_rotation_groups_edit === 'allow' &&
          currentAcl.service_rotation_groups_view === 'allow') ||
          adminAcl.is_superuser
      "
      :is-open="isOpenRotationGroupsPopup"
      :inital-data="rotationGroups"
      @close="closeRotationGroupsPopup"
      @save="updateRotationGroupsForAffiliate"
    />
    <UiConfirm
      ref="confirm"
      :width="480"
      :type="confirmData.type"
      :action-name="confirmData.actionName"
      :action-icon="confirmData.icon"
      :close-action-name="$t('affiliates.delete_offer.cancel')"
      @save="confirmData.handleSave"
    >
      <template v-slot:title>
        <div>
          {{ confirmData.title }}
        </div>
      </template>

      <div class="body__wrap">
        <i
          class="warning fas fa-exclamation-triangle t:mr-12"
        />
        <div
          class="body__msg"
          v-html="confirmData.msg"
        />
      </div>
    </UiConfirm>
    <div
      v-if="rotationGroups.length"
      class="card"
    >
      <div class="title">
        <div class="title-content">
          <span>{{
            $t('affiliates.affiliatesInfo.rotation_groups_setting')
          }}</span>
          <span
            v-if="editPermission"
            :style="{ color: 'var(--text-primary)' }"
            class="action"
            @click="addRotationGroupsHandler"
          >
            <UiIcon
              name="plus"
              color="var(--text-negative)"
            />
            {{ $t(`affiliates.offer_popup.Add`) }}
          </span>
        </div>
      </div>
      <div class="card-content">
        <div
          v-for="item in rotationGroups"
          :key="item.id"
          class="field without-padding"
        >
          <div class="card">
            <div class="field">
              <div class="column">
                <div class="column-text">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="item.type !== 'primary' && editPermission"
            class="field"
          >
            <span
              class="action success"
              @click="handlerConfirm('setMain', item)"
            >
              <UiIcon
                name="check"
                class="success"
              />
              {{ $t('affiliates.affiliatesInfo.set_as_main') }}
            </span>
            <span
              class="action danger"
              @click="handlerConfirm('delete', item)"
            >
              <UiIcon
                name="trash-alt"
                class="danger"
                color="var(--text-negative)"
              />
              {{ $t(`affiliates.affiliatePromocode.delete_promocode`) }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AffiliateRotationGroupsPopup from '@/components/Popups/AffiliateRotationGroupsPopup.vue';

export default {
  name: 'RotationGroupsCard',

  components: {
    AffiliateRotationGroupsPopup,
  },

  props: {
    editPermission: {
      type: Boolean,
      default: false,
    },

    id: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      rotationGroups: [],
      isOpenRotationGroupsPopup: false,
      currentRotation: {},
      confirmData: {
        actionName: '',
        type: '',
        icon: '',
        title: '',
        msg: '',
        handleSave: Function,
      },
    };
  },

  computed: {
    ...mapGetters({
      currentAcl: 'auth/currentAcl',
      adminAcl: 'auth/adminAcl',
    }),
  },

  methods: {
    async deleteRotation() {
      try {
        await this.$api.deleteRotationGroupsForAffiliate(
          this.id,
          this.currentRotation.id,
        );
      } finally {
        this.getRotationGroupsForAffiliate(this.id);
        this.cancelHandler();
      }
    },

    async setMain() {
      try {
        await this.$api.setPrimeryRotationGroupsForAffiliate(
          this.id,
          this.currentRotation.id,
        );
      } finally {
        this.getRotationGroupsForAffiliate(this.id);
        this.cancelHandler();
      }
    },

    cancelHandler() {
      this.$refs.confirm.close();
    },

    handlerConfirm(action, data) {
      if(action === 'delete') {
        this.confirmData = {
          type: 'warning',
          actionName: this.$t('affiliates.affiliatePromocode.delete_promocode'),
          title: this.$t('affiliates.confirn_rotation_delete.title'),
          msg: this.$t('affiliates.confirn_rotation_delete.text'),
          icon: 'trash',
          handleSave: this.deleteRotation,
        };
      }
      if (action === 'setMain') {
        this.confirmData = {
          type: 'success',
          actionName: this.$t('affiliates.affiliatesInfo.set_as_main'),
          title: this.$t('affiliates.confirn_rotation_set_main.title'),
          msg: this.$t('affiliates.confirn_rotation_set_main.text'),
          icon: 'check',
          handleSave: this.setMain,
        };
      }
      this.currentRotation = data;
      this.$refs.confirm.open();
    },

    async addRotationGroupsHandler() {
      this.openRotationGroupsPopup();
    },

    openRotationGroupsPopup() {
      this.isOpenRotationGroupsPopup = true;
    },

    closeRotationGroupsPopup() {
      this.isOpenRotationGroupsPopup = false;
    },

    async updateRotationGroupsForAffiliate(data) {
      try {
        await this.$api.addRotationGroupsForAffiliate(this.id, data);
      } finally {
        this.getRotationGroupsForAffiliate(this.id);
      }
    },

    async getRotationGroupsForAffiliate(id) {
      try {
        const {
          data: { payload },
        } = await this.$api.getRotationGroupsForAffiliate(id);
        this.rotationGroups = payload.sort(
          (a, b) => a.type.length - b.type.length,
        );
      } catch (error) {
        this.rotationGroups = [];
      }
    },
  },
};
</script>
